import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Flame, Eye, MessageSquareOff } from 'lucide-react';
export function Problems() {
  const problems = [{
    icon: <Flame className="w-8 h-8 text-plum" strokeWidth={1.5} data-id="element-304" />,
    title: 'REACTIVITATEA',
    subtitle: 'ȚIPĂT . TRÂNTESC . REGRET',
    text: 'Explici ceva de trei ori și simți că tensiunea urcă spre cap. Țipi, trântești ușa, apoi te întrebi cum ai putut să reacționezi așa. Te devalorizezi ca mamă, ca soț, ca partener, ca om. A doua zi, la fel.'
  }, {
    icon: <Eye className="w-8 h-8 text-plum" strokeWidth={1.5} data-id="element-305" />,
    title: 'VIGILENȚA',
    subtitle: 'PANICĂ . CONTROL . EPUIZARE',
    text: 'Ești mereu cu ochii în patru. Simți că, dacă lași garda jos o clipă, se întâmplă ceva rău cu copilul, cu soțul, cu tine. Pericole peste tot. Crezi că nu te poți baza pe nimeni și trebuie să duci totul pe umerii tăi.'
  }, {
    icon: <MessageSquareOff className="w-8 h-8 text-plum" strokeWidth={1.5} data-id="element-306" />,
    title: 'NEÎNȚELEGEREA',
    subtitle: 'CONFLICT . DISTANȚĂ . SINGURĂTATE',
    text: 'Tu spui una, celălalt înțelege altceva. Parcă nu vorbiți aceeași limbă. Te oprești din a-ți spune părerea ca să eviți scandalul și înghiți. Cu cât eviți, cu atât distanța crește. Te întrebi dacă mai e de salvat ceva aici.'
  }];
  return <section className="bg-plum py-12 md:py-20" data-id="element-307">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-308">
        <FadeIn data-id="element-309">
          <div className="text-center max-w-[720px] mx-auto mb-16 md:mb-20" data-id="element-310">
            <h2 className="text-[32px] md:text-[48px] font-medium leading-[1.15] mb-6 text-cream" data-id="element-311">
              Te regăsești în cel puțin una din aceste situații?
            </h2>
            <div className="w-20 h-[1px] bg-cream/20 mx-auto relative" data-id="element-312">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 bg-orange rounded-full" data-id="element-313"></div>
            </div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-314">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-315">
              <div className="bg-cream border border-plum-border rounded-[16px] p-8 md:p-10 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 h-full flex flex-col group" data-id="element-316">
                <div className="w-16 h-16 rounded-full bg-plum/10 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-317">
                  {problem.icon}
                </div>

                <h3 className="text-[20px] md:text-[24px] font-semibold mb-2 uppercase tracking-wide" data-id="element-318">
                  {problem.title}
                </h3>

                <h4 className="text-[14px] md:text-[16px] font-medium text-warmgray mb-6 tracking-wider" data-id="element-319">
                  {problem.subtitle}
                </h4>

                <p className="text-[17px] md:text-[19px] text-plum-light leading-[1.65] mt-auto" data-id="element-320">
                  {problem.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}